import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ role, children }) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="loading-page">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const loginPath = role === 'dio' ? '/dio/login' : '/team/login';
    return <Navigate to={loginPath} replace />;
  }

  if (role && user?.role !== role) {
    const redirectPath = user?.role === 'dio' ? '/dio/dashboard' : '/team/staff';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
}
